var React = require('react');

function HandCoins (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.8 17.63a3.06 3.06 0 0 0-2.66-.53l-5.23 1.2A3.5 3.5 0 0 0 17.5 14h-6.26a3.98 3.98 0 0 0-2.83 1.17L5.6 18H2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h13a1 1 0 0 0 .24-.03l8-2 .15-.05 4.86-2.07.05-.02a3.07 3.07 0 0 0 .5-5.2ZM2 20h3v5H2v-5Zm25.43 1.03-4.75 2.02-7.8 1.95H7v-5.59l2.83-2.82a1.98 1.98 0 0 1 1.41-.59h6.26a1.5 1.5 0 1 1 0 3H14a1 1 0 0 0 0 2h4c.08 0 .15 0 .22-.02l8.38-1.93.04-.01a1.07 1.07 0 0 1 .79 1.99ZM20.5 12c.25 0 .5-.02.74-.06a4.5 4.5 0 1 0 3.53-5.87A4.5 4.5 0 1 0 20.5 12Zm7.5-1.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM20.5 5a2.5 2.5 0 0 1 2.4 1.83 4.5 4.5 0 0 0-1.87 3.11A2.5 2.5 0 1 1 20.5 5Z"}));
}

HandCoins.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = HandCoins;

HandCoins.default = HandCoins;
